import { EditHumanResource } from 'features/SubmitProjectProposal/pages';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function EditHumanResourcePage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <div className=" m-0 bg-white p-5 p-fluid">
          <EditHumanResource />
        </div>
      </Layout>
    </LayoutProvider>
  );
}

export default EditHumanResourcePage;
